<script setup lang="ts">
/**
 * Quiz/Header 3188:14753 — glass close (44), progress bar, right slot
 * None / Counter ("7 / 24") / Skip.
 */
import { computed } from 'vue'
import { FairIcon } from '@/ui/primitives/FairIcon'

interface FairQuizHeaderProps {
  /** 0…1 */
  progress?: number
  right?: 'none' | 'counter' | 'skip'
  counter?: string
  skipLabel?: string
  closeLabel?: string
  progressLabel?: string
}

const props = withDefaults(defineProps<FairQuizHeaderProps>(), {
  progress: 0,
  right: 'none',
  counter: '',
  skipLabel: 'Skip',
  closeLabel: 'Close',
  progressLabel: undefined,
})

const emit = defineEmits<{
  close: []
  skip: []
}>()

const percent = computed(() => Math.round(Math.max(0, Math.min(1, props.progress)) * 100))
</script>

<template>
  <header class="fair-quiz-header">
    <button
      type="button"
      class="fair-quiz-header__close"
      :aria-label="closeLabel"
      @click="emit('close')"
    >
      <FairIcon
        name="close-small"
        :size="24"
      />
    </button>

    <div
      class="fair-quiz-header__track"
      role="progressbar"
      :aria-valuenow="percent"
      aria-valuemin="0"
      aria-valuemax="100"
      :aria-label="progressLabel"
    >
      <span
        v-if="percent > 0"
        class="fair-quiz-header__fill"
        :style="{ width: `calc(${percent}% + 2px)` }"
      />
    </div>

    <span
      v-if="right === 'counter'"
      class="fair-quiz-header__counter"
    >{{ counter }}</span>

    <button
      v-else-if="right === 'skip'"
      type="button"
      class="fair-quiz-header__skip"
      @click="emit('skip')"
    >
      {{ skipLabel }}
    </button>
  </header>
</template>
